export default "__VITE_ASSET__a418fbff__"